import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { Navbar, Footer } from './Layout';
import Home          from './pages/Home';
import AboutPage     from './pages/AboutPage';
import ServicesPage  from './pages/ServicesPage';
import GalleryPage   from './pages/GalleryPage';
import IndustriesPage from './pages/IndustriesPage';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/about"      element={<AboutPage />} />
          <Route path="/services"   element={<ServicesPage />} />
          <Route path="/gallery"    element={<GalleryPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
